import { notification } from 'antd'

import { FileEntityType, fileService } from 'services/FileService'

export interface ConvertedFile {
  content: string
  name: string
  format: string
  fileSize: number
}

export const handleFileInput = async (input: React.ChangeEvent<HTMLInputElement>): Promise<ConvertedFile> => {
  const localFile: File | null = input.target.files?.length ? input.target.files[0] : null

  if (!localFile) {
    return {
      content: '',
      name: '',
      format: '',
      fileSize: 0,
    }
  }

  return createFileData(localFile)
}

export const handleFilesInput = async (input: React.ChangeEvent<HTMLInputElement>): Promise<ConvertedFile[]> => {
  const localFiles: FileList | null = input.target.files?.length ? input.target.files : null

  if (!localFiles) {
    return [
      {
        content: '',
        name: '',
        format: '',
        fileSize: 0,
      },
    ]
  }

  const result = []

  for (let i = 0; i < localFiles.length; i++) {
    result.push(await createFileData(localFiles[i]))
  }

  return result
}

const createFileData = async (localFile: File) => {
  return new Promise<ConvertedFile>((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = (event) => {
      if (typeof event.target?.result === 'string') {
        const dataUrl = event.target.result as string
        const base64String = dataUrl.split(',')[1]
        const fileNameParts = localFile.name.split('.')
        const fileFormat = fileNameParts[fileNameParts.length - 1].toLowerCase()

        resolve({
          content: `data:${localFile.type};base64,${base64String}`,
          name: localFile.name,
          format: fileFormat,
          fileSize: dataUrl.length,
        })
      } else {
        reject(new Error('Ошибка чтения файла. FileReader вернул некорректный результат'))
      }
    }

    reader.onerror = reject
    reader.readAsDataURL(localFile)
  })
}

export const uploadFile = async (localFile: File) => {
  const file = await createFileData(localFile)

  try {
    if (file?.content) {
      const resp = await fileService.fileUpload({
        entityId: 27197170,
        totalSize: file.fileSize,
        content: file.content,
        entityType: FileEntityType.user,
        requestFromPromo: true,
      })

      if (resp) {
        notification.success({
          message: 'Файл загружен',
        })

        return resp.imageUrl
      }
    }
  } catch (error) {
    notification.error({
      message: 'Ошибка',
      description: `Произошла ошибка: ${error}`,
    })
  }
}
